import styles from "./index.module.scss";

interface ISubmitBtnProps {
  text: string;
  disabled: boolean;
  className?: string;
}
export const SubmitBtn = ({ text, disabled, className }: ISubmitBtnProps) => {
  return (
    <button
      type="submit"
      className={`${styles.submitBtn} ${className}`}
      disabled={disabled}
    >
      {text}
    </button>
  );
};
